// Main Provider
import React from 'react';
import type { ATContextProviderProps } from './types';
import { ATColumnsContextProvider } from './useATColumns';
import { ATFilterAdvancedContextProvider } from './useATFilterAdvanced';
import { ATFilterContextProvider } from './useATFilter';
import { ATSelectionContextProvider } from './useATSelection';
import { ATisActiveContextProvider } from './useATisActive';
import { ATPageContextProvider } from './useATPage';

export const ATContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  return (
    <ATColumnsContextProvider>
      <ATFilterAdvancedContextProvider>
        <ATFilterContextProvider>
          <ATSelectionContextProvider>
            <ATisActiveContextProvider>
              <ATPageContextProvider>{children}</ATPageContextProvider>
            </ATisActiveContextProvider>
          </ATSelectionContextProvider>
        </ATFilterContextProvider>
      </ATFilterAdvancedContextProvider>
    </ATColumnsContextProvider>
  );
};
